import {
	clearEmbedToken,
	getEmbedToken,
	isEmbedContext,
} from 'src/components/embed/utils';

interface CookieOptions {
	path?: string;
	domain?: string;
}

export function setCookie(
	name: string,
	value: string,
	days?: number,
	options: CookieOptions = {},
) {
	let expires = '';
	if (days) {
		const date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = `expires=${date.toUTCString()}`;
	}
	const { path, domain } = options;
	const cookieString = `${name}=${value || ''}${expires ? `; ${expires}` : ''}${path ? `; path=${path}` : ''}${domain ? `; domain=${domain}` : ''}`;
	document.cookie = cookieString;
}

export function getCookie(cookieName: string): string | null {
	const nameEquals = `${cookieName}=`;
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i += 1) {
		const currentCookie = cookies[i].trim();
		if (currentCookie.startsWith(nameEquals)) {
			return currentCookie.substring(nameEquals.length);
		}
	}
	return null;
}

export function getDomain() {
	const parts = window?.location?.hostname?.split('.');
	if (parts?.length > 2) {
		return parts.slice(-2).join('.');
	}
	return '';
}

export function deleteCookie(name: string) {
	const domain = getDomain();
	const expires = 'expires=Thu, 01 Jan 1970 00:00:00 UTC';
	document.cookie = `${name}=; ${expires}; path=/; domain=${domain};`;
	document.cookie = `${name}=; ${expires}; path=/;`;
}

export const ADMIN_LOGIN_AS_CUSTOMER_KEY = 'admin_login_as_customer';
export const CUSTOMER_USER_ACCESS_COOKIE = 'customerUserAccess';
export const USER_ACCESS_TOKEN_KEY = 'userAccessToken';

export function clearAccessToken() {
	// Embed token is in-memory and takes priority — clear it first when in an
	// iframe so a leftover admin_login_as_customer key doesn't shadow it.
	if (isEmbedContext()) {
		clearEmbedToken();
		return;
	}
	if (localStorage.getItem(ADMIN_LOGIN_AS_CUSTOMER_KEY)) {
		localStorage.removeItem(ADMIN_LOGIN_AS_CUSTOMER_KEY);
		localStorage.removeItem(USER_ACCESS_TOKEN_KEY);
		return;
	}
	deleteCookie(CUSTOMER_USER_ACCESS_COOKIE);
}

export function getToken() {
	// Embed token is in-memory and must take priority over localStorage when
	// running inside the extension iframe — otherwise a leftover
	// admin_login_as_customer key returns the previous customer's token and the
	// new admin-generated token is silently ignored.
	if (isEmbedContext()) {
		return getEmbedToken();
	}
	if (localStorage.getItem(ADMIN_LOGIN_AS_CUSTOMER_KEY)) {
		return localStorage.getItem(USER_ACCESS_TOKEN_KEY);
	}
	return getCookie(CUSTOMER_USER_ACCESS_COOKIE);
}
